import React, {useState} from 'react';

const ImageWithFallback = (props) => {
    const {fallbackColor, itemTitle, height, width} = props;
    const [hasError, setHasError] = useState(false);

    if(hasError) return (
        <div
            className="icon-with-letter"
            style={{
                height: height || '40px',
                width: width || '40px',
                backgroundColor: fallbackColor || 'black',
                color: 'white',
            }}>{itemTitle && itemTitle[0].toUpperCase()}</div>
    );

    // <div className="icon-with-letter" style={{backgroundColor: entity.color}}>
    //     {entity.title && entity.title[0]}
    // </div>

    return (
        <img {...props} onError={() => setHasError(true)}/>
    );
};

export default ImageWithFallback;
